<template>
    <div class="common-layout">
        <layoutHeader></layoutHeader>
        <div class="common-inner">
            <layoutAside></layoutAside>
            <div class="common-main">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import layoutHeader from './components/layoutHeader.vue';
import layoutAside from './components/layoutAside.vue';

@Options({
    components: {
        layoutHeader,
        layoutAside
    },
})
export default class LayoutComp extends Vue {

}


</script>
<style lang="scss" scoped>
.common-inner {
    display: flex;
    .common-main {
        flex: 1;
        padding: 20px;
        background: url("@/assets/img/bj1.jpg") no-repeat;
        background-size: 100% 100%;
        overflow: auto;
        box-sizing: border-box;
        height: calc(100vh - 60px);
    }
}
</style>
